import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Define window.gtag as a function
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

const GoogleAnalytics = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Track page views on route change
    if (typeof window.gtag === 'function') {
      window.gtag('config', 'G-622BG3T4MK', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  // This component doesn't render anything
  return null;
};

// Function to track custom events
export const trackEvent = (
  eventName: string,
  eventParams: Record<string, any> = {}
) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, eventParams);
  }
};

export default GoogleAnalytics; 